import React from "react";

import { useTranslation } from "react-i18next";

import { TIME_FORMAT } from "../../../constants/dateFormat";
import { convertMillisecondsDurationToHMS } from "../../../utils/durations";

import type { Moment } from "moment";
import type { JSX, ReactNode } from "react";

export const MEDIA_TOOLTIP_WIDTH = 140;
export const MEDIA_TOOLTIP_HEIGHT = 85;

interface ContentTooltipItemProps {
  title?: string | ReactNode;
  duration?: number;
  startTime?: Moment;
  startTimeLabel?: string;
  endTime?: Moment;
  endTimeLabel?: string;
  image?: string | null;
}

function ContentTooltipItem({
  startTime,
  startTimeLabel,
  endTime,
  endTimeLabel,
  duration,
  title,
  image,
}: ContentTooltipItemProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const formattedDuration =
    duration && convertMillisecondsDurationToHMS(duration);

  return (
    <div
      className="flex items-center justify-center gap-[0.78125rem]"
      style={{
        minWidth: MEDIA_TOOLTIP_WIDTH,
        maxWidth: image ? MEDIA_TOOLTIP_WIDTH * 3 : MEDIA_TOOLTIP_WIDTH * 2,
      }}
    >
      {image ? (
        <div
          className="aspect-video h-[85px] bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${image})`,
            height: MEDIA_TOOLTIP_HEIGHT,
          }}
        />
      ) : null}
      <div className="flex flex-col gap-[0.3125rem] text-left">
        {title ? <span className="text-center break-all">{title}</span> : null}
        {formattedDuration ? (
          <div className="flex justify-between gap-[0.46875rem] text-nowrap">
            <span>{t("duration")}</span>
            <span className="font-semibold">{formattedDuration}</span>
          </div>
        ) : null}
        {startTime ? (
          <div className="flex justify-between gap-[0.46875rem] text-nowrap">
            <span>{startTimeLabel ?? t("startTime")}</span>
            <span className="font-semibold">
              {startTime?.format(TIME_FORMAT)}
            </span>
          </div>
        ) : null}
        {endTime ? (
          <div className="flex justify-between gap-[0.46875rem] text-nowrap">
            <span>{endTimeLabel ?? t("endTime")}</span>
            <span className="font-semibold">
              {endTime?.format(TIME_FORMAT)}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ContentTooltipItem;
